<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.preparings'), $t('text.list')]"
      ></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.serialNo"
            :placeholder="$t('order.serialNo')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.customerName"
            :placeholder="$t('menu.customers')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
          ></el-input>
        </el-form-item>
        <el-form-item :prop="'categoryName'">
          <el-select
            size="small"
            v-model="searchForm.categoryName"
            :placeholder="$t('product.category')"
            clearable
            filterable
          >
            <el-option
              v-for="category in categories"
              :key="category.id"
              :label="category.name"
              :value="category.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.color"
            :placeholder="$t('product.color')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.size"
            :placeholder="$t('product.size')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.specJson"
            :placeholder="$t('product.specJson')"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            v-model="searchForm"
            type="datetime"
            field="handOverAt"
            :start-placeholder="$t('rules.startAt', [$t('text.handOverAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.handOverAt')])"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button
              class="mgr10"
              type="primary"
              size="mini"
              :loading="batchPreparedDoing"
              @click="barchPrepared"
              >{{ $t("orderStates.prepared") }}</el-button
            >
            <el-dropdown @command="print">
              <el-button type="defalut" size="mini">
                {{ $t("action.printPickingList") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="printA4Div">{{
                  $t("action.printA4")
                }}</el-dropdown-item>
                <el-dropdown-item command="printTPDiv">{{
                  $t("action.pringTP")
                }}</el-dropdown-item>
                <el-dropdown-item command="printQrCodeDiv">{{
                  $t("action.printQrCode")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :checkbox-config="{ reserve: true, checkMethod: checCheckboxMethod }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        ref="recordsTable"
        class="recordsTable"
        :row-class-name="rowBgColor"
        size="mini"
        id="pendingsTable"
        row-id="id"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="checkbox" type="checkbox" width="35" />
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="130"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            <a @click="showRecord(row)">
              {{ row.serialNo }}
            </a>
            <div>
              <state-label :state="row.workflowState">
                {{ $t("orderStates." + row.workflowState) }}
              </state-label>
            </div>
            <div class="font10">
              {{ $t("menu.customers") }}:{{ row.customerName }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.customerProductNo != null && row.customerProductNo != ''
              "
              >({{ row.customerProductNo }})</small
            >
            <div class="font10">
              {{ row.categoryName }}
              <span v-if="row.productBrand != null">/</span>
              {{ row.productBrand }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="12"
              type="richText"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="specJson"
          :title="$t('product.specJson')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <attribute :content="row.specJson" :number="12" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit }}
            <div class="font10">
              {{ $t("order.dealQuantity") }}: {{ row.dealQuantity }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          v-if="
            !Permit.isFreeEdition() && Permit.extendModels().includes('wms')
          "
          :title="$t('order.wmsInfo')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <div v-for="i of row.inventories" :key="i.id" class="font10">
              {{ i.shopName }}：{{ i.quantity }}/{{ i.customQuantity }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          width="110"
          sortable
        />

        <vxe-table-column
          field="dealRemark"
          :title="$t('order.dealRemark')"
          min-width="80"
        >
          <template v-slot="{ row, rowIndex }">
            <i
              slot="reference"
              class="el-icon-edit fl"
              @click="editDealRemark(row, rowIndex)"
            />
            <raw-html-limit-number :content="row.dealRemark" :number="20" />
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="ownerName"
          :title="$t('text.owner')"
          min-width="80"
        />
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          width="110"
        />
        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          width="150"
          fixed="right"
        >
          <template v-slot="{ row, rowIndex }">
            <el-button
              v-if="
                row.quantity > row.dealQuantity &&
                ['preparing', 'shipped', 'partially'].includes(
                  row.workflowState
                )
              "
              type="text"
              size="mini"
              @click="preparedRow(row, rowIndex)"
            >
              {{ $t("orderStates.prepared") }}
            </el-button>

            <el-button
              v-if="
                ['preparing', 'prepared'].includes(row.workflowState) &&
                !(row.deliveredQuantity > 0)
              "
              type="text"
              size="mini"
              @click="retriveToPenging(row)"
              >{{ $t("action.retriveToPenging") }}</el-button
            >
            <div>
              <el-button
                v-if="
                  row.workflowState == 'preparing' &&
                  Permit.extendModels().includes('wms')
                "
                type="text"
                size="mini"
                @click="changeSpec(row)"
                >{{ $t("action.changeSpec") }}</el-button
              >
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <!-- ======== -->
    <drawer
      :title="$t('text.view', [$t('menu.bargains')])"
      :visible.sync="show"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer>
    <!-- ==== -->
    <el-dialog
      :title="$t('orderStates.prepared')"
      :close-on-click-modal="false"
      :visible.sync="batchPreparedDF"
      width="50"
    >
      <el-form
        ref="batchPreparedObjForm"
        :model="batchPreparedObj"
        label-width="70px"
      >
        <el-form-item
          :label="$t('order.warehouse')"
          :prop="'shopId'"
          :rules="[
            {
              required: true,
              message: $t('rules.select', [$t('order.warehouse')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model.trim="batchPreparedObj.shopId"
            clearable
            filterable
            @change="selectShop"
            style="width: 240px"
          >
            <el-option
              v-for="shop in shopsInv"
              :key="shop.id"
              :label="shop.name"
              :value="shop.id"
            />
          </el-select>
        </el-form-item>
        <vxe-table
          :data="selectRecords"
          size="mini"
          resizable
          round
          highlight-hover-row
          auto-resize
          :scroll-y="{ enabled: false }"
        >
          <vxe-table-column
            field="images"
            :title="$t('product.images')"
            width="85"
          >
            <template v-slot="{ row }">
              <thumbnail :images="row.images"></thumbnail>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="serialNo"
            :title="$t('text.serialNo')"
            min-width="100"
          >
            <template v-slot="{ row }">
              <small v-if="row.hurry" class="red">
                ({{ $t("order.hurrySimple") }})
              </small>
              {{ row.serialNo }}
              <div>
                <state-label :state="row.workflowState">
                  {{ $t("orderStates." + row.workflowState) }}
                </state-label>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="productNo"
            :title="$t('product.productNo')"
            min-width="100"
          >
            <template v-slot="{ row }">
              {{ row.productNo }}
              <div class="font10">{{ row.color }} {{ row.size }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="quantity"
            :title="$t('text.quantity')"
            width="100"
          >
            <template v-slot="{ row }">
              <span :class="Number(row.quantity) > 1 ? 'red font18' : ''">
                {{ row.quantity }}{{ row.unit }}
              </span>
              <div class="font10">
                {{ $t("order.dealQuantity") }}: {{ row.dealQuantity }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            v-if="
              !Permit.isFreeEdition() && Permit.extendModels().includes('wms')
            "
            :title="$t('order.wmsInfo')"
            min-width="110"
          >
            <template v-slot="{ row }">
              <span v-if="row.errorMessage != null" class="red font10">{{
                row.errorMessage
              }}</span>
              <div v-for="i of row.inventories" :key="i.id" class="font10">
                {{ i.shopName }}：{{ i.quantity }}/{{ i.customQuantity }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="handOverAt"
            :title="$t('text.handOverAt')"
            width="110"
          ></vxe-table-column>
          <vxe-table-column
            field="action"
            :title="$t('text.action')"
            width="50"
          >
            <template v-slot="{ row, rowIndex }">
              <el-button type="text" @click="remove(row, rowIndex)" size="mini">
                {{ $t("text.remove") }}
              </el-button>
            </template>
          </vxe-table-column>
        </vxe-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <span class="mgr10">
          {{ $t("text.total") }}：{{ computeQuantity() }}
        </span>
        <el-button
          type="primary"
          plain
          :loading="batchPreparedSubmitDoing"
          size="small"
          @click="batchPreparedSubmit"
        >
          {{ $t("text.submit") }}
        </el-button>
        <el-button size="small" @click="batchPreparedDF = false">
          {{ $t("text.close") }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 编辑处理备注 -->
    <el-dialog
      :title="$t('rules.edit', [$t('order.dealRemark')])"
      :close-on-click-modal="false"
      :visible.sync="editDealRemarkDF"
      width="30%"
    >
      <el-form label-width="80px">
        <el-input
          size="small"
          v-model.trim="editDealRemarkObj.dealRemark"
          type="textarea"
          :autosize="{ minRows: 6 }"
          class="mgb10"
        />
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDealRemarkDoing"
          size="small"
          @click="editDealRemarkSubmit"
        >
          {{ $t("text.submit") }}
        </el-button>
        <el-button size="small" @click="editDealRemarkDF = false">
          {{ $t("text.close") }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 单个备货完成 -->
    <el-dialog
      :title="$t('orderStates.prepared')"
      :close-on-click-modal="false"
      :visible.sync="preparedRowDF"
      width="30%"
    >
      <el-form
        ref="preparedRowObjForm"
        :model="preparedRowObj"
        label-width="70px"
      >
        <el-form-item
          :label="$t('text.quantity')"
          :prop="'dealQuantity'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="preparedRowObj.dealQuantity"
            :placeholder="preparedRowObj._maxDealQuantity"
          />
        </el-form-item>
        <el-form-item
          v-if="!Permit.isFreeEdition()"
          :label="$t('order.warehouse')"
          :prop="'shopId'"
          :rules="[
            {
              required: true,
              message: $t('rules.select', [$t('order.warehouse')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model.trim="preparedRowObj.shopId"
            clearable
            filterable
          >
            <el-option
              v-for="shop in shopsInv"
              :key="shop.id"
              :label="shop.text"
              :value="shop.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="preparedRowSubmitDoing"
          size="small"
          @click="preparedRowSubmit"
        >
          {{ $t("text.submit") }}
        </el-button>
        <el-button size="small" @click="preparedRowDF = false">
          {{ $t("text.close") }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 改码备货 -->
    <el-dialog
      :title="$t('action.changeSpec')"
      :close-on-click-modal="false"
      :visible.sync="changeSpecDF"
      width="30%"
    >
      <el-form
        ref="changeSpecObjForm"
        :model="changeSpecObj"
        label-width="70px"
      >
        <el-form-item
          :prop="'shopId'"
          :label="$t('order.warehouse')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('order.warehouse')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="changeSpecObj.shopId"
            clearable
            filterable
            @change="selectChangeSpecShop"
          >
            <el-option
              v-for="shop in shopsInv"
              :key="shop.id"
              :label="shop.name"
              :value="shop.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-table :data="changeSpecInvs" style="width: 100%" border size="mini">
          <el-table-column :label="$t('product.size')" prop="size" />
          <el-table-column :label="$t('inventory.quantity')" prop="quantity" />
          <el-table-column
            :label="$t('inventory.totalLock')"
            prop="customQuantity"
          />
          <el-table-column field="action" :label="$t('text.action')" width="80">
            <template slot-scope="scope">
              <el-button
                v-if="
                  scope.row.quantity - scope.row.customQuantity >= row.quantity
                "
                type="text"
                size="mini"
                :loading="changeSpecSubmitDoing"
                @click="changeSpecSubmit(scope.row)"
                >{{ $t("action.changeSpec") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="changeSpecDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 打印 -->
    <el-dialog
      :title="$t('action.print')"
      :close-on-click-modal="false"
      :visible.sync="printDF"
      width="60%"
    >
      <vxe-table
        :data="printComputeBargains"
        :merge-cells="printMergeCells"
        id="bargainsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        :row-class-name="calculateBgColor"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <span v-if="!row.isBargain">
              <thumbnail :images="row.images"></thumbnail>
            </span>
            <div v-else>
              <span class="float-left">
                <span class="mgr5">{{ row.serialNo }}</span>
              </span>
              <span class="float-right font10 mgr5">
                <el-popover placement="right" width="300" trigger="click">
                  <div>
                    <div class="lineH24">
                      {{ $t("menu.customers") }}：{{ row.customerName }}
                    </div>
                    <div class="lineH24">
                      {{ $t("bargain.customerPhone") }}：
                      {{ row.customerPhone }}
                    </div>
                    <div class="lineH24">
                      {{ $t("tenant.country") }}：
                      <span v-if="row.customerCountry != null">{{
                        $t("countries." + row.customerCountry)
                      }}</span>
                    </div>
                    <div class="lineH24">
                      {{ $t("tenant.province") }}：{{ row.customerProvince }}
                    </div>
                    <div class="lineH24">
                      {{ $t("tenant.city") }}：{{ row.customerCity }}
                    </div>
                    <div class="lineH24">
                      {{ $t("tenant.address") }}：{{ row.customerAddress }}
                    </div>
                    <div class="lineH24">
                      {{ $t("customer.zipcode") }}：{{ row.customerZipcode }}
                    </div>
                  </div>
                  <span slot="reference" class="popover-reference">
                    {{ $t("menu.customers") }}：{{ row.customerName }}
                  </span>
                </el-popover>
              </span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="120"
        />

        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.handOverAt }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit || "" }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="10"
              type="richText"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="dealRemark"
          :title="$t('order.dealRemark')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.dealRemark"
              :number="10"
              type="richText"
            />
          </template>
        </vxe-table-column>
      </vxe-table>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="printSubmitDoing"
          size="small"
          @click="printSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="printDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <div id="printTPDiv" style="display: none">
      <div>
        <table
          v-for="item in printData"
          :key="item.id"
          style="
            width: 80mm;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            margin-bottom: 20px;
          "
        >
          <tr style="border: 1px solid #dfe5ec; text-align: center">
            <td>
              <barcode :value="item.serialNo" height="40px"></barcode>
            </td>
          </tr>

          <tr style="border: 1px solid #dfe5ec">
            <td>
              <div v-for="i of item.selectedOrders" :key="i.id">
                {{ i.productNo }}（{{ i.categoryName }}&nbsp;{{
                  i.color
                }}&nbsp;{{ i.size }}）：{{ i.quantity }}{{ i.unit }}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              {{ item.customerName }}
              <div>{{ item.customerPhone }}</div>
              <div>
                <span v-if="item.customerCountry != null">{{
                  $t("countries." + item.customerCountry)
                }}</span>
                {{ item.customerProvince }}{{ item.customerCity
                }}{{ item.customerAddress }}
              </div>
              <div>{{ item.customerZipcode }}</div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div id="printA4Div" style="display: none">
      <div>
        <table
          v-for="item in printData"
          :key="item.id"
          style="
            width: 130mm;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            margin-bottom: 20px;
          "
        >
          <tr style="border: 1px solid #dfe5ec">
            <td style="width: 80mm; height: 60px">
              <barcode :value="item.serialNo" height="40px"></barcode>
            </td>
            <td style="border: 1px solid #dfe5ec" rowspan="3">
              <div v-for="i of item.selectedOrders" :key="i.id">
                <img
                  v-if="i.firstImage != null"
                  :src="i.firstImage"
                  alt
                  style="width: 80px; float: left; margin-left: 5px"
                />
              </div>
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec">
            <td>
              <div v-for="i of item.selectedOrders" :key="i.id">
                {{ i.productNo }}（{{ i.categoryName }}&nbsp;{{
                  i.color
                }}&nbsp;{{ i.size }}）：{{ i.quantity }}{{ i.unit }}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              {{ item.customerName }}
              <div>{{ item.customerPhone }}</div>
              <div>
                <span v-if="item.customerCountry != null">{{
                  $t("countries." + item.customerCountry)
                }}</span>
                {{ item.customerProvince }}{{ item.customerCity
                }}{{ item.customerAddress }}
              </div>
              <div>{{ item.customerZipcode }}</div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div id="printQrCodeDiv" style="display: none">
      <div
        v-for="(cp, index) in selectRecords"
        :key="cp.id"
        :style="
          'margin:0 auto 10px; width:200px; text-align:left; font-size: 14px;' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <div>
          <qrcode
            :value="`${cp.serialNo}`"
            :options="{ width: 100 }"
            :tag="'img'"
          />
        </div>
        <div style="padding-left: 10px">
         {{ cp.serialNo }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { page, table } from "@/utils/mixins.js";
import Barcode from "vue-barcode";
import Qrcode from "@chenfengyuan/vue-qrcode";
import Util from "@/utils/index.js";
import DateRange from "@/components/DateRange";
import Order from "@/api/order.js";
import Shop from "@/api/shop.js";
import Inventory from "@/api/inventory.js";
import Bargain from "@/api/bargain.js";
import Show from "../bargains/showOrder.vue";
import Category from "@/api/category";
export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    DateRange,
    Barcode,
    Qrcode,
    Show,
  },

  data() {
    return {
      sorter: {
        sortBy: "orders_id",
        sortIndicator: "desc",
      },
      sorterMap: {
        productNo: "orders_productNo",
        handOverAt: "orders_handOverAt",
      },
      narrows: [
        [
          {
            label: this.$t("order.nearRange"),
            items: Order.nearRange,
          },
          {
            label: this.$t("order.passRange"),
            items: Order.passRange,
          },
        ],
        [
          {
            label: this.$t("text.workflowState"),
            items: [
              {
                label: "备货处理中",
                key: "unFinshed",
                condition: {
                  workflowStates: ["preparing", "shipped", "partially"],
                  dealt: "no",
                },
              },
              {
                label: this.$t("orderStates.prepared"),
                key: "prepared",
                condition: {
                  workflowStates: ["prepared"],
                },
              },
            ],
          },
          {
            label: this.$t("text.special"),
            items: [
              {
                label: this.$t("order.hurry"),
                key: "hurryYes",
                condition: { hurry: "yes" },
              },
            ],
          },
        ],
      ],
      initFilter: "unFinshed",
      searchForm: {
        serialNo: null,
        customerName: null,
        productNo: null,
        categoryName: null,
        color: null,
        size: null,
        handOverAtStartAt: null,
        handOverAtEndAt: null,
        specJson: null,
      },
      shops: [],
      shopsInv: [],
      categories: [],
      //
      currentRowIdx: null,
      //
      show: false,
      currentRowId: null,
      // 编辑处理备注
      editDealRemarkDF: false,
      editDealRemarkObj: {
        dealRemark: null,
        id: null,
      },
      editDealRemarkDoing: false,
      // 批量备货完毕
      batchPreparedDF: false,
      batchPreparedObj: {
        shopId: null,
      },
      batchPreparedDoing: false,
      batchPreparedSubmitDoing: false,
      batchPreparedInvNotEnougth: [],
      // 单个备货完毕
      currentRowIdx: null,
      preparedRowDF: false,
      preparedRowObj: {
        id: null,
        dealQuantity: null,
        shopId: null,
        _maxDealQuantity: null,
      },
      preparedRowSubmitDoing: false,
      //改码出库
      row: null,
      changeSpecDF: false,
      changeSpecObj: {
        shopId: null,
      },
      changeSpecInvs: [],
      changeSpecSubmitDoing: false,
      //
      printDF: false,
      printType: null,
      printData: [],
      printComputeBargains: [],
      printMergeCells: [],
      printSubmitDoing: false,
    };
  },
  computed: {
    implicit() {
      return {
        dealTypes: ["available"],
      };
    },
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    this.loadingStart();
    Shop.findByTenantId().then(function (res) {
      if (res.status === 200) {
        self.shops = res.data;
        self.shopsInv = res.data.filter((s) => s.isInventory === true);
        for (const shop of self.shopsInv) {
          Vue.set(shop, "text", shop.name);
        }
        self.getCategory();
      } else {
        self.sysError();
      }
      self.loadingEnd();
    });
  },
  methods: {
    getCategory() {
      const self = this;
      Category.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.categories = res.data;
        } else {
          self.sysError();
        }
      });
    },
    // 打印
    print(cmd) {
      const self = this;
      if (this.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.printType = cmd;
      if (cmd == "printQrCodeDiv") {
        self.printFunction(self.printType);
        return;
      }
      const ids = this.selectRecords.map((c) => c.bargainId);
      const idsSet = [...new Set(ids)];
      Bargain.findByIds(idsSet).then(function (res) {
        if (res.status == 200) {
          self.printData = res.data.map((d) => {
            return {
              id: d.id,
              serialNo: d.serialNo,
              customerName: d.customerName,
              customerPhone: d.customerPhone,
              customerCountry: d.customerCountry,
              customerProvince: d.customerProvince,
              customerCity: d.customerCity,
              customerAddress: d.customerAddress,
              customerZipcode: d.customerZipcode,
              selectedOrders: self.selectRecords.filter(
                (co) => co.bargainId === d.id
              ),
            };
          });
          self.printComputeBargains = self.buildTableData(self.printData);
          self.printMergeCells = self.buildMergeCells(self.printData);
          self.printDF = true;
        } else {
          self.sysError();
        }
      });
    },
    //
    buildTableData(records) {
      let rs = [];
      records.forEach((record) => {
        let bOrder = {
          isBargain: true,
          id: record.id,
          serialNo: record.serialNo,
          customerName: record.customerName,
          customerPhone: record.customerPhone,
          customerCountry: record.customerCountry,
          customerProvince: record.customerProvince,
          customerCity: record.customerCity,
          customerAddress: record.customerAddress,
          customerZipcode: record.customerZipcode,
          orders: record.selectedOrders,
        };
        rs.push(bOrder); //将bargain的数据转换到格式，放到数据列表
        record.selectedOrders.forEach((order) => {
          rs.push(order);
        });
      });
      return rs;
    },
    buildMergeCells(bargains) {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < bargains.length; i++) {
        mcs.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 7 });
        rowIdx = rowIdx + bargains[i].selectedOrders.length + 1;
      }
      return mcs;
    },
    calculateBgColor({ row, rowIndex }) {
      return row.isBargain ? "light-blue-bg" : "";
    },
    printSubmit() {
      const self = this;
      self.printFunction(self.printType);
      self.printDF = false;
    },
    //改码
    changeSpec(row) {
      const self = this;
      self.row = row;
      self.changeSpecObj.shopId = null;
      self.changeSpecSubmitDoing = false;
      self.changeSpecDF = true;
    },
    selectChangeSpecShop() {
      const self = this;
      self.changeSpecInvs = [];
      if (self.changeSpecObj.shopId != null) {
        const obj = {
          shopId: self.changeSpecObj.shopId,
          productNo: self.row.productNo,
          color: self.row.color,
        };
        Inventory.findByProductInfoWithoutSize(obj).then(function (res) {
          if (res.status == 200) {
            if (
              res.data.length !== 0 &&
              res.data.filter((r) => r.size != self.row.size).length != 0
            ) {
              self.changeSpecInvs = res.data.filter(
                (r) => r.size != self.row.size
              );
            } else {
              self.$message({
                message: self.$t("prompt.notExistDiffSpecPoduct"),
                type: "warning",
              });
            }
          } else {
            self.sysError();
          }
        });
      }
    },
    changeSpecSubmit(row) {
      const self = this;
      const obj = {
        shopId: self.changeSpecObj.shopId,
        newSize: row.size,
        orderId: self.row.id,
      };
      self.changeSpecSubmitDoing = true;
      Order.changeSpecPrepared(obj).then(function (res) {
        self.changeSpecSubmitDoing = false;
        self.changeSpecDF = false;
        if (res.status === 200) {
          self.sysResult(res.data);
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 撤回待处理
    retriveToPenging(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmRetriveToPenging"))) {
        Order.availableRepending(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.dealSuccess"),
              type: "success",
            });
            self.loadData();
            self.$eventHub.$emit("orderAvailableRepending");
          } else {
            self.sysError();
          }
        });
      }
    },
    // 单个备货完毕
    preparedRow(row, rowIndex) {
      const self = this;
      self.currentRowIdx = rowIndex;
      self.preparedRowObj.id = row.id;
      self.preparedRowObj.dealQuantity = row.quantity - row.dealQuantity;
      self.preparedRowObj._maxDealQuantity = row.quantity - row.dealQuantity;
      self.preparedRowObj.shopId = null;
      if (self.Permit.extendModels().includes("wms")) {
        for (const shop of self.shopsInv) {
          const invObj = row.inventories.find((i) => i.shopId == shop.id);
          if (invObj != null) {
            shop.text =
              shop.name +
              "(库存:" +
              invObj.quantity +
              "/锁定:" +
              invObj.totalLock +
              ")";
          } else {
            shop.text = shop.name + "(无库存产品)";
          }
        }
      }
      self.preparedRowSubmitDoing = false;
      self.preparedRowDF = true;
    },
    preparedRowSubmit() {
      const self = this;
      self.$refs.preparedRowObjForm.validate((valid) => {
        if (valid) {
          if (self.Permit.isFreeEdition()) {
            self.preparedRowObj.shopId = self.shops[0].id;
          }
          if (
            !Util.regexQuantity(self.preparedRowObj.dealQuantity) ||
            self.preparedRowObj.dealQuantity === "0" ||
            self.preparedRowObj.dealQuantity >
              self.preparedRowObj._maxDealQuantity
          ) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          self.preparedRowSubmitDoing = true;
          Order.availablePartDeal(self.preparedRowObj).then(function (res) {
            self.preparedRowSubmitDoing = false;
            self.preparedRowDF = false;
            if (res.status == 200) {
              self.loadData();
              self.sysResult(res.data);
              self.$eventHub.$emit("orderAvailablePartDeal");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //
    barchPrepared() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      if (self.Permit.isFreeEdition()) {
        // 免费
        const data = self.selectRecords.map((s) => {
          return { id: s.id, shopId: self.shops[0].id };
        });
        self.batchPreparedDoing = true;
        Order.batchPrepared(data).then(function (res) {
          self.batchPreparedDoing = false;
          if (res.status == 200) {
            self.sysResults(res.data, self.$t("prompt.dealSuccess"));
            self.loadData();
            self.$eventHub.$emit("orderBatchPrepared");
          } else {
            self.sysError();
          }
        });
      } else {
        //收费
        self.batchPreparedDF = true;
        self.batchPreparedObj.shopId = null;
      }
    },
    computeQuantity() {
      if (this.selectRecords.length == 0) {
        return 0;
      }
      let totalQuantity = 0;
      for (const d of this.selectRecords) {
        totalQuantity = totalQuantity + (d.quantity - d.dealQuantity);
      }
      return totalQuantity;
    },
    remove(row, rowIndex) {
      this.selectRecords.splice(rowIndex, 1);
      this.selectShop();
    },
    selectShop() {
      const self = this;
      self.batchPreparedInvNotEnougth = [];
      if (self.Permit.extendModels().includes("wms")) {
        for (const row of self.selectRecords) {
          if (row.inventories.length == 0) {
            Vue.set(row, "errorMessage", "库存不存在");
            self.batchPreparedInvNotEnougth.push(row);
            continue;
          }
          const obj = row.inventories.find(
            (i) => i.shopId == self.batchPreparedObj.shopId
          );
          if (obj == null) {
            Vue.set(row, "errorMessage", "库存不存在");
            self.batchPreparedInvNotEnougth.push(row);
            continue;
          }
          if (
            obj &&
            row.quantity - row.dealQuantity > obj.quantity - obj.totalLock
          ) {
            Vue.set(row, "errorMessage", "库存数量不足");
            self.batchPreparedInvNotEnougth.push(row);
            continue;
          }
          Vue.set(row, "errorMessage", null);
        }
      }
      //
    },
    batchPreparedSubmit() {
      const self = this;
      self.$refs.batchPreparedObjForm.validate((valid) => {
        if (valid) {
          if (self.selectRecords.length == 0) {
            self.$message.error(this.$t("prompt.atLeastOneData"));
            return;
          }
          if (
            self.Permit.extendModels().includes("wms") &&
            self.batchPreparedInvNotEnougth.length != 0
          ) {
            self.$message({
              message: self.$t("prompt.errorMessage"),
              type: "warning",
            });
            return;
          }

          const data = self.selectRecords.map((s) => {
            return { id: s.id, shopId: self.batchPreparedObj.shopId };
          });
          self.batchPreparedSubmitDoing = true;
          Order.batchPrepared(data).then(function (res) {
            self.batchPreparedSubmitDoing = false;
            self.batchPreparedDF = false;
            if (res.status == 200) {
              self.sysResults(res.data, self.$t("prompt.dealSuccess"));
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 编辑处理备注
    editDealRemark(row, rowIndex) {
      const self = this;
      self.currentRowIdx = rowIndex;
      self.editDealRemarkObj.dealRemark = row.dealRemark;
      self.editDealRemarkObj.id = row.id;
      self.editDealRemarkDoing = false;
      self.editDealRemarkDF = true;
    },
    editDealRemarkSubmit() {
      const self = this;
      self.editDealRemarkDoing = true;
      Order.updateDealRemark(self.editDealRemarkObj).then(function (res) {
        self.editDealRemarkDoing = false;
        self.editDealRemarkDF = false;
        if (res.status === 200) {
          self.records[self.currentRowIdx].dealRemark =
            self.editDealRemarkObj.dealRemark;
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },

    showRecord(order) {
      this.currentRowId = order.id;
      this.show = true;
    },
    //======
    dataProvider(params) {
      return Order.search(params);
    },
    isNear(row) {
      //定义近交期
      const noColorWorkflowStates = ["canceled", "returned", "finished"];
      if (
        !noColorWorkflowStates.includes(row.workflowState) &&
        row.handOverAt != null
      ) {
        if (
          Util.dateDiff(row.handOverAt, new Date()) <=
            this.Permit.currentTenant().config.nearDays &&
          Util.dateDiff(row.handOverAt, new Date()) > 0
        ) {
          return true;
        }
      }
      return false;
    },
    isPass(row) {
      //定义过交期
      const noColorWorkflowStates = ["canceled", "returned", "finished"];
      if (
        !noColorWorkflowStates.includes(row.workflowState) &&
        row.handOverAt != null
      ) {
        if (Util.dateDiff(row.handOverAt, new Date()) <= 0) {
          return true;
        }
      }
      return false;
    },

    // 可选
    checCheckboxMethod({ row }) {
      if (
        ["preparing", "shipped", "partially"].includes(row.workflowState) &&
        row.dealQuantity < row.quantity
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>
